/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Feature } from './Feature';
import {
    FeatureFromJSON,
    FeatureFromJSONTyped,
    FeatureToJSON,
} from './Feature';
import type { PlasmidViewSequenceTypeConstants } from './PlasmidViewSequenceTypeConstants';
import {
    PlasmidViewSequenceTypeConstantsFromJSON,
    PlasmidViewSequenceTypeConstantsFromJSONTyped,
    PlasmidViewSequenceTypeConstantsToJSON,
} from './PlasmidViewSequenceTypeConstants';

/**
 * Optional plasmid view [used by: PlasmidView]
 * @export
 * @interface PlasmidView
 */
export interface PlasmidView {
    /**
     * 
     * @type {Array<Feature>}
     * @memberof PlasmidView
     */
    features: Array<Feature>;
    /**
     * 
     * @type {string}
     * @memberof PlasmidView
     */
    fullSequence: string;
    /**
     * 
     * @type {PlasmidViewSequenceTypeConstants}
     * @memberof PlasmidView
     */
    sequenceType: PlasmidViewSequenceTypeConstants;
}

/**
 * Check if a given object implements the PlasmidView interface.
 */
export function instanceOfPlasmidView(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "features" in value;
    isInstance = isInstance && "fullSequence" in value;
    isInstance = isInstance && "sequenceType" in value;

    return isInstance;
}

export function PlasmidViewFromJSON(json: any): PlasmidView {
    return PlasmidViewFromJSONTyped(json, false);
}

export function PlasmidViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlasmidView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'features': ((json['features'] as Array<any>).map(FeatureFromJSON)),
        'fullSequence': json['fullSequence'],
        'sequenceType': PlasmidViewSequenceTypeConstantsFromJSON(json['sequenceType']),
    };
}

export function PlasmidViewToJSON(value?: PlasmidView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'features': ((value.features as Array<any>).map(FeatureToJSON)),
        'fullSequence': value.fullSequence,
        'sequenceType': PlasmidViewSequenceTypeConstantsToJSON(value.sequenceType),
    };
}

